<template>
  <div>
    <v-text-field
      v-model="formData.tanggal"
      type="date"
      label="Tanggal"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="fetchLaporan"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <h1 class="report-title mr-5">LAPORAN BIAYA BURUH HARIAN</h1>
      </div>

      <div class="mt-4">
        <div class="head">
          <table style="width: 100%">
            <tr>
              <td width="20%">TANGGAL</td>
              <td width="2%">:</td>
              <td>{{ formatDate(formData.tanggal) }}</td>
            </tr>
          </table>
        </div>

        <br />

        <table width="100%" class="table-border">
          <thead>
            <th width="5%" class="text-center">NO</th>
            <th width="15%" class="text-center">NO TRANSAKSI</th>
            <th width="10%" class="text-center">KV</th>
            <th width="10%" class="text-center">KATEGORI UPAH</th>
            <th width="20%" class="text-center">Keterangan</th>
            <th width="10%" class="text-center">PENAGIH</th>
            <th width="10%" class="text-center">NOMINAL</th>
          </thead>

          <tbody>
            <tr v-for="(item, i) in data" :key="item.id">
              <td class="text-center">{{ i + 1 }}</td>
              <td class="text-center">{{ item.nomor_nota }}</td>
              <td class="text-center">
                {{ item.kv }}
              </td>
              <td class="text-center">
                {{ item.kategori_upah || "-" }}
              </td>
              <td class="text-center">
                {{ item.keterangan || "-" }}
              </td>
              <td class="text-center">
                {{ item.nama_penagih }}
              </td>
              <td class="text-center">
                {{ formatCurrency(Math.abs(item.total)) }}
              </td>
            </tr>
            <tr>
              <td colspan="6" class="text-right">TOTAL</td>
              <td class="text-center">{{ grandtotal_biaya }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        tanggal: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    grandtotal_biaya() {
      let total = 0;

      this.data.forEach(item => {
        total += Math.abs(item.total);
      });

      return this.formatCurrency(total);
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      await axios
        .get(`biaya-buruh/laporan-biaya-buruh?tanggal=${this.formData.tanggal}`)
        .then(res => {
          if (!res.data) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.head {
  display: flex;
}

table {
  border-collapse: collapse;
}

.table-border,
.table-border th,
.table-border td {
  border: 2px solid black;
  border-collapse: collapse;
}

.table-border td {
  padding: 2px;
}

@page {
  size: auto;
}
</style>
